/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserDto } from '../../models/user-dto';

export interface UsersControllerGetCurrentUser$Params {
  /**
   * Store identifier for multi-tenant requests.
   */
  'terrific-store-id'?: string;
}

export function usersControllerGetCurrentUser(
  http: HttpClient,
  rootUrl: string,
  params?: UsersControllerGetCurrentUser$Params,
  context?: HttpContext
): Observable<StrictHttpResponse<UserDto>> {
  const rb = new RequestBuilder(rootUrl, usersControllerGetCurrentUser.PATH, 'get');
  if (params) {
    rb.header('terrific-store-id', params['terrific-store-id'], {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserDto>;
    })
  );
}

usersControllerGetCurrentUser.PATH = '/api/v1/users/get-current-user';
